import type {
  CmsApiBlock,
  CmsApiBlockType,
} from '#/modules/cms/api/types/CmsApiBlock';
import type { CmsMappedBlock } from '#/modules/cms/mappers/CmsMappedBlock';

const blocksWithoutDividers = new Set<CmsApiBlockType>([
  'CTA_HERO',
  'STICKY_HEADER_LINKS',
  'EMAIL_CAMPAIGN_SIGNUP_SINGLE',
  'EMAIL_CAMPAIGN_SIGNUP_DOUBLE',
  'FORM_BUILDER',
  'FLASH_CARD_QUIZ',
  'SIGN_UP',
  'SCROLL_TRACKING',
  'RECOMMENDED_JOBS',
]);

export function mustNotHaveDivider<TBlock extends CmsApiBlock>(
  block: CmsMappedBlock<TBlock>,
) {
  return blocksWithoutDividers.has(block.type) || block.mustNotHaveDivider;
}
